import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Babysitting = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">Babysitting Services</h1>
          <p className="lead text-warning fw-bold">Reliable and Flexible Childcare When You Need It</p>
          <Link to="/klassicare">
            <Button variant="outline-warning" className="mt-3">
              <i className="bi bi-arrow-left me-2"></i>
              Back to KlassiCare
            </Button>
          </Link>
        </div>

        <Row className="g-4 mb-5">
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Regular Babysitting</Card.Title>
                <Card.Text className="text-primary">
                  Consistent care for your children with trusted babysitters.
                  Perfect for working parents who need regular support.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Date Night Care</Card.Title>
                <Card.Text className="text-primary">
                  Evening and weekend babysitting services for special occasions.
                  Give yourself time to relax while your children are in good hands.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 bg-dark-subtle border-warning">
              <Card.Body>
                <Card.Title className="text-light h3 mb-3">Emergency Care</Card.Title>
                <Card.Text className="text-primary">
                  Last-minute babysitting solutions for unexpected situations.
                  Quick response and reliable care when you need it most.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Our Babysitters</h2>
              <ul className="text-primary">
                <li className="mb-2">Thoroughly screened and background-checked</li>
                <li className="mb-2">CPR and First Aid certified</li>
                <li className="mb-2">Experienced with children of all ages</li>
                <li className="mb-2">References available upon request</li>
                <li className="mb-2">Regular training and skill development</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Booking Process</h2>
              <p className="text-primary mb-4">
                Getting started with our babysitting services is easy:
              </p>
              <ol className="text-primary">
                <li className="mb-2">Create your family profile</li>
                <li className="mb-2">Schedule a consultation</li>
                <li className="mb-2">Meet potential babysitters</li>
                <li className="mb-2">Book your preferred schedule</li>
                <li className="mb-2">Enjoy peace of mind</li>
              </ol>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Babysitting; 